import { Injectable } from '@angular/core';
import { Conseil } from "../models/conseil";
import { Deserialize } from "cerialize";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ConseilService {

  baseApiUrl: string = environment.api.baseUrl;

  private _conseils: BehaviorSubject<Conseil[]> = new BehaviorSubject(null);
  public readonly conseils: Observable<Conseil[]> = this._conseils.asObservable().pipe(filter(conseils => conseils != null));

  constructor(private http: HttpClient) {
  }

  load(): Observable<Conseil[]> {
    return this.http.get(`${this.baseApiUrl}conseils`).pipe(switchMap(data => {
        this._conseils.next(Deserialize(data, Conseil));
        return this.conseils;
      })
    );
  }

  findById(id: number): Observable<Conseil> {
    if(this._conseils.value == null){
      this.load().toPromise();
    }
    return this.conseils.pipe(map(conseils => conseils.find(conseil => conseil.id == id)));
  }
}
